function insertWhiteboards() {
  const whiteboards = document.querySelectorAll('.embedded-whiteboard-json');

  whiteboards.forEach((element: HTMLElement) => {
    if (
      !element.id ||
      !element.dataset.json ||
      !element.dataset.attachmentUrls
    ) {
      return;
    }

    const json = JSON.parse(element.dataset.json);
    const attachmentUrls = JSON.parse(element.dataset.attachmentUrls);
    const id = element.id.replace('whiteboard_json_', '');

    // sometimes there is an additional hidden whiteboard element, we need to only initialise the visible one
    const nodes = [
      ...document.querySelectorAll<HTMLElement>(`[data-whiteboard-id="${id}"]`),
    ];
    const node =
      nodes.length > 1 ? nodes.find(node => $(node).is(':visible')) : nodes[0];

    if (node) {
      // Setting data-react-props and data-react-class will automatically run the mountNode code.
      node.dataset.reactProps = JSON.stringify({
        canPresent: false,
        initialData: json,
        attachmentUrls,
        readOnly: true,
      });
      node.dataset.reactClass = 'Whiteboard';
    }
  });
}

document.addEventListener('page:change', insertWhiteboards);
